export const GET_SENDBIRD_USER_LIST = 'GET_SENDBIRD_USER_LIST'
export const SET_SENDBIRD_USER_LIST = 'SET_SENDBIRD_USER_LIST'
export const SET_SENDBIRD_CONNECT_STATE = 'SET_SENDBIRD_CONNECT_STATE'
export const GET_SENDBIRD_CLIENT_USER_LIST = 'GET_SENDBIRD_CLIENT_USER_LIST'
export const SET_SENDBIRD_CLIENT_USER_LIST = 'SET_SENDBIRD_CLIENT_USER_LIST'
export const SET_PROFILE_SENDBIRD = 'SET_PROFILE_SENDBIRD'
export const SET_CLIENT_SENDBIRD = 'SET_CLIENT_SENDBIRD'
